import { ICNEA_PROPERTY_ALREADY_LINKED_ERROR } from "./error-codes.constants";

export class IcneaPropertyAlreadyLinkedError extends Error {
  code: string;
  conflictingRoomName?: string;

  constructor(conflictingRoomName?: string) {
    super("Icnea property already linked error");
    this.name = "IcneaPropertyAlreadyLinkedError";
    this.code = ICNEA_PROPERTY_ALREADY_LINKED_ERROR;
    this.conflictingRoomName = conflictingRoomName;
  }
}
